import { useMemo } from 'react';
import { getAppConfig } from './app-config';

export function useAppConfig() {
  const url = new URL(window.location.href);

  const protocolAndHost = `${url.protocol}//${url.host}`;

  return useMemo(() => {
    const config = getAppConfig(protocolAndHost);

    return config;
  }, [protocolAndHost]);
}
